import Banner from "../../../components/banner";
import Feed from "./feed";
import Filters from "./filters";
import "../../../misc/snake-branding";

window.Feed = Feed;
window.Filters = Filters;

document.body.addEventListener("feed.update", () => {
    const main = document.querySelector(".sheet__main");

    if (!main) {
        return;
    }
    
    main.querySelectorAll("[data-config-item]")
    .forEach(banner => new Banner(banner));
});
